import React from "react";
import { Box, Typography } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";

import { i18n } from "../../../translate/i18n";
import { useStyles } from "../messagesAPIStyles";
import EndpointCard, { CodeBlock } from "./EndpointCard";

const BAILEYS_BADGE = { label: "BAILEYS", color: "#25D366" };

const ExternalApiReference = ({ apiBase }) => {
  const classes = useStyles();
  const t = (k, o) => i18n.t(`messagesAPI.section5.${k}`, o);

  return (
    <Box>
      <Alert severity="info" style={{ marginBottom: 16 }}>
        {t("intro")}
      </Alert>

      <CodeBlock label={t("baseUrl")}>{apiBase}</CodeBlock>
      <Typography className={classes.epDesc} style={{ marginTop: 8 }}>
        <strong>{t("headersLine")}</strong> <code>Authorization: Bearer &lt;TOKEN&gt;</code>
      </Typography>

      {/* Consultas (GET) */}
      <EndpointCard
        method="GET"
        path={`${apiBase}/ticket?number=51980795334`}
        badges={[BAILEYS_BADGE]}
        title={t("getTicketByNumber")}
        description={t("d.byNumber")}
        response={`{ "variables": { "atendimento": 1223, "nome": "Juan", "numero": "51980795334", "status": "open", "canal": "whatsapp", "user": "Agente", "queue": "Ventas", "tags": ["VIP"] } }`}
        curl={`curl -H "Authorization: Bearer <TOKEN>" "${apiBase}/ticket?number=51980795334"`}
      />

      <EndpointCard
        method="GET"
        path={`${apiBase}/ticket/:ticketId`}
        badges={[BAILEYS_BADGE]}
        title={t("getTicketById")}
        description={t("d.byId")}
        curl={`curl -H "Authorization: Bearer <TOKEN>" "${apiBase}/ticket/123"`}
      />

      <EndpointCard
        method="GET"
        path={`${apiBase}/users`}
        badges={[BAILEYS_BADGE]}
        title={t("getUsers")}
        description={t("d.users")}
        curl={`curl -H "Authorization: Bearer <TOKEN>" "${apiBase}/users"`}
      />

      <EndpointCard
        method="GET"
        path={`${apiBase}/tags`}
        badges={[BAILEYS_BADGE]}
        title={t("getTags")}
        description={t("d.tags")}
        curl={`curl -H "Authorization: Bearer <TOKEN>" "${apiBase}/tags"`}
      />

      {/* Acciones (PUT) */}
      <EndpointCard
        method="PUT"
        path={`${apiBase}/ticket/:ticketId/tag`}
        badges={[BAILEYS_BADGE]}
        title={t("putAssignTag")}
        description={t("d.assignTag")}
        params={[{ name: "tagId", value: t("d.tagIdValue") }]}
        request={`{ "tagId": 1 }`}
        curl={`curl -X PUT "${apiBase}/ticket/123/tag" \\\n  -H "Authorization: Bearer <TOKEN>" \\\n  -H "Content-Type: application/json" \\\n  -d '{ "tagId": 1 }'`}
      />

      <EndpointCard
        method="PUT"
        path={`${apiBase}/ticket/:ticketId`}
        badges={[BAILEYS_BADGE]}
        title={t("putUpdateTicket")}
        description={t("d.updateTicket")}
        params={[
          { name: "status", value: t("d.statusValue") },
          { name: "userId", value: t("d.userIdValue") },
          { name: "queueId", value: t("d.queueIdValue") },
        ]}
        request={`{ "status": "open", "userId": 1, "queueId": 2 }`}
        curl={`curl -X PUT "${apiBase}/ticket/123" \\\n  -H "Authorization: Bearer <TOKEN>" \\\n  -H "Content-Type: application/json" \\\n  -d '{ "status": "open", "userId": 1, "queueId": 2 }'`}
      />

      {/* Compatibilidad Typebot / N8N (autocontenida, sin referencias internas) */}
      <EndpointCard
        method="POST"
        path={`${apiBase}/ticket`}
        badges={[BAILEYS_BADGE]}
        title={t("d.typebotTitle")}
        description={t("d.typebotDesc")}
        params={[
          { name: "number", value: t("d.typebotNumber") },
          { name: "atendimento", value: t("d.typebotAtendimento") },
        ]}
        request={`{ "number": "51980795334" }`}
        response={`{ "variables": { "atendimento": 1223, "nome": "Juan", "numero": "51980795334", "status": "open" } }`}
        curl={`curl -X POST "${apiBase}/ticket?number=51980795334" \\\n  -H "Authorization: Bearer <TOKEN>"`}
        note={t("d.typebotNote")}
        noteSeverity="info"
      />

      {/* Objeto variables devuelto en las respuestas */}
      <Typography className={classes.codeLabel}>{t("variablesObjectTitle")}</Typography>
      <Typography className={classes.epDesc}>{t("d.variablesDesc")}</Typography>
      <CodeBlock>{t("variablesList")}</CodeBlock>
    </Box>
  );
};

export default ExternalApiReference;
